<script setup>
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import {useAnnotationFilters} from "@/composables/admin/useSeoScoreAnnotations";

const {orderDirection, orderBy, changeOrderBy} = useAnnotationFilters();
</script>

<template>
  <TableHeaderRow>
    <TableHeaderCell
      col-span="3"
      :order-by="orderBy"
      :order-direction="orderDirection"
      name="title"
      @order-changed="changeOrderBy"
    >
      <span>Title</span>
    </TableHeaderCell>

    <TableHeaderCell
      col-span="2"
      :order-by="orderBy"
      :order-direction="orderDirection"
      name="date"
      @order-changed="changeOrderBy"
    >
      <span>Date</span>
    </TableHeaderCell>

    <TableHeaderCell
      col-span="5"
      :order-by="orderBy"
      :order-direction="orderDirection"
      name="description"
      @order-changed="changeOrderBy"
    >
      <span>Description</span>
    </TableHeaderCell>

    <TableHeaderCell col-span="2" />
  </TableHeaderRow>
</template>
